module.exports = __webpack_public_path__ + "components/star-rating/static/yellow/0.5-1dd015684ff8995fb12ef5a0972cf860.svg";